import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { UserDbService } from "../service/user-db.service";
import { UserManagementEffects } from "./effects";
import { reducer } from "./reducers";

@NgModule({
    imports: [
        MatSnackBarModule,
        MatDialogModule,
        MatButtonModule,
        StoreModule.forFeature("user-management", reducer),
        EffectsModule.forFeature([UserManagementEffects]),
    ],
    providers: [UserManagementEffects, UserDbService],
})
export class UserManagementStoreModule {}
